"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestmentPaymentRequest = void 0;
var InvestmentPaymentRequest = /** @class */ (function () {
    function InvestmentPaymentRequest() {
    }
    return InvestmentPaymentRequest;
}());
exports.InvestmentPaymentRequest = InvestmentPaymentRequest;
;
//# sourceMappingURL=investmentPayment.request.js.map